import styles from './PaymentMethodLogos.module.css'
import classNames from 'classnames'
import { Media } from '../Media/Media'

const paymentMethodLogos = [
  {
    alt: 'Visa Logo',
    filename: 'VisaLogo',
  },
  {
    alt: 'Mastercard Logo',
    filename: 'MastercardLogo',
  },
  {
    alt: 'Apple Pay Logo',
    filename: 'ApplePayLogo',
  },
  {
    alt: 'Amex Logo',
    filename: 'AmexLogo',
  },
  {
    alt: 'PayPal Logo',
    filename: 'PaypalLogo',
  },
]

interface PaymentMethodLogosProps {
  position: 'left' | 'right' | 'center'
  variant: 'light' | 'dark'
  isGrey?: boolean
}

export const PaymentMethodLogos = ({ position, variant, isGrey }: PaymentMethodLogosProps) => {
  const bucket = 'https://cdn.huel.io/media/payment-logos/'

  const classes = classNames(styles.PaymentMethodLogos, {
    [styles[`PaymentMethodLogos--${position}`]]: position,
    [styles[`PaymentMethodLogos--is-grey`]]: isGrey,
  })
  return (
    <div className={classes}>
      {paymentMethodLogos.map(({ alt, filename }) => (
        <div key={alt} className={styles.PaymentMethodLogos__item}>
          <Media
            src={`${bucket}${filename}-${variant}.png`}
            config={{
              size: {
                style: 'fixed',
                value: 100,
              },
              alt,
              widthAuto: true,
            }}
          />
        </div>
      ))}
    </div>
  )
}
